var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-style my-5"},[_c('h4',[_vm._v(_vm._s(_vm.separator_text))]),_c('hr')])
}
var staticRenderFns = []

export { render, staticRenderFns }